import {debounce, put, takeLatest, call} from 'redux-saga/effects';
import {productActions} from "./productSlice";
import {productApi} from "~/api";

function* handleGetProductList(action) {
	try
	{
		const response = yield call(productApi.gets, action.payload);
		yield put(productActions.fetchDataSuccess(response));
	}
	catch (error)
	{
		yield put(productActions.fetchDataFailed(error.message));
	}
}

function* searchWithDebounce(action) {
	yield put(productActions.setFilter(action.payload));
}

function* productSaga() {
	yield takeLatest(productActions.fetchData.type, handleGetProductList);
	yield debounce(500, productActions.setFilterWithDebounce.type, searchWithDebounce);
}

export default productSaga;
